import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MobileWarningModal.module.css';
import { useNavigate } from 'react-router-dom';

interface MobileWarningModalProps {
  show: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const MobileWarningModal: React.FC<MobileWarningModalProps> = ({ show, onClose, onContinue }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navHome = () => {
    navigate('/');
  };
  
  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <span className={styles.warningIcon}>⚠️</span>
          <h2>{t('mobileWarning.title')}</h2>
        </div>
        
        <div className={styles.modalBody}>
          <p className={styles.mainMessage}>
            {t('mobileWarning.mainMessage')}
          </p>
          
          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <span className={styles.icon}>💻</span>
              <span>{t('mobileWarning.features.workspace')}</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.icon}>⚡</span>
              <span>{t('mobileWarning.features.performance')}</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.icon}>🎯</span>
              <span>{t('mobileWarning.features.tools')}</span>
            </div>
          </div>
          
          <p className={styles.recommendation}>
            <strong>{t('mobileWarning.recommendationLabel')}</strong> {t('mobileWarning.recommendation')}
          </p>
        </div>
        
        <div className={styles.modalActions}>
          <button className={styles.primaryButton} onClick={navHome}>
            {t('mobileWarning.buttons.goBack')}
          </button>
          {/* DO NO CHANGE THIS */}
          {/* <button className={styles.secondaryButton} onClick={onContinue}>
            {t('mobileWarning.buttons.continue')}
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default MobileWarningModal;
